// 실제 본문을 찾아 이동한다. 이미 열린 native dialog의 키보드 포커스는 빼앗지 않는다.
export function focusSiteMain({ scroll = false } = {}) {
  if (document.querySelector('dialog[open]')) return false
  const main = document.querySelector('main')
  if (!main) return false
  main.tabIndex = -1
  if (document.activeElement !== main) main.focus({ preventScroll: !scroll })
  if (scroll) main.scrollIntoView({ block: 'start' })
  return document.activeElement === main
}
